import PropTypes from 'prop-types'
import React from 'react'

import { HEADER_HEIGHT, FOOTER_HEIGHT } from '@/utils/constants'

/**
 * AppShell
 *
 * A component that provides a consistent layout for the application.
 *
 * @param {boolean} skipLayout - If true, skip layout styles.
 * @param {React.ReactNode} children - The content to be rendered inside the layout.
 * @returns {JSX.Element} - The rendered component.
 */
const AppShell = ({ children, skipFooter = false, skipLayout = false }) => {
  if (skipLayout) return children

  // Adjust the height to ensure that the minimum height accounts for the header and footer
  let height = HEADER_HEIGHT
  if (!skipFooter) {
    height += FOOTER_HEIGHT
  }

  return (
    <div
      className="bg-background flex w-full flex-col overflow-y-auto px-4 py-6 sm:px-6 lg:px-8"
      style={{ minHeight: `calc(100vh - ${height}px)` }}
    >
      {children}
    </div>
  )
}

AppShell.propTypes = {
  skipFooter: PropTypes.bool,
  skipLayout: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default AppShell
